import React, { useState, useEffect } from "react";
import "./userpage.css";
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { database } from "../../database/firebase";
import { getFirestore, increment, serverTimestamp, doc, getDoc, updateDoc, addDoc, setDoc, collection, query, orderBy, where, getDocs, onSnapshot, listCollections, Timestamp } from "firebase/firestore";
import UseHandleConnection from "../../functions/UseHandleConnection";
import Swal from "sweetalert2"; // Import SweetAlert2 for better UI feedback
import Modal from "react-modal";
import axios from "axios";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FaBook } from "react-icons/fa"; // Font Awesome

Modal.setAppElement("#root");

function UserPage({ updateHeader }) {
  const navigate = useNavigate();
  const [userData, setUserData] = useState(null);
  const [themeData, setThemeData] = useState(null);
  const [marketopen, setmarketopenData] = useState(null);
  const [marketinfo, setmarketInfoData] = useState(null);
  const [initialfund, setinitialfundData] = useState(null);

  const [stocks, setStocks] = useState([]);
  const [portfolio, setPortfolio] = useState([]);
  const [allPortfolio, setAllPortfolio] = useState([]);
  const [news, setNews] = useState([]);
  const [purchaseStock, setPurchaseStock] = useState({ symbol: "", quantity: "" });
  const storedSession = sessionStorage.getItem("userData");
  const [currentuserId, setcurrentuserId] = useState(null);
  const [accountBalance, setaccountBalance] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedStock, setSelectedStock] = useState(null);
  const [quantity, setQuantity] = useState("")
  const [accountId, setAccountdocId] = useState("")
  const [activeButton, setActiveButton] = useState(null);
  const [orderLoader, setOrderLoaderButton] = useState(false);
  const [userAccount, setuserAcount] = useState(false);
  const [transactionCharge, setTransactionCharge] = useState(false);
  const [textcolor, Setcolorcode] = useState(null);
  const [expandedStock, setExpandedStock] = useState(null);
  // const [popupBg, setpopupBg] = useState("/img/popup2.png");

  const toggleExpand = (id) => {
    setExpandedStock(expandedStock === id ? null : id);
  };


  const handleSuccess = (msg) => {
    Swal.fire({
      text: msg,
      customClass: {
        popup: 'custom-success-popup' // Apply your custom class
      }
    });
  };
const handlePop = (name,msg) => {
  return Swal.fire({
    title: name,
    html: `<div style="align-items: center; gap: 0px;">
         <img src="/img/bulb.png" style="width:18px; height:18px;">
         <span>${msg}</span>
       </div>`,
    customClass: {
      popup: 'learningbites-success-popup' // Apply your custom class
    }
  });
};

  const handleError = (msg) => {
    Swal.fire({
      title: 'Oops...',
      text: msg,
      customClass: {
        popup: 'custom-success-popup' // Apply your custom class
      }
    });
  };


  useEffect(() => {
    updateHeader({
      backButtonRedirect: "/game"
    });
    const storedSession = sessionStorage.getItem("userData");
    const storedTheme = sessionStorage.getItem("themeData");

    if (storedSession && storedTheme) {
      setThemeData(JSON.parse(storedTheme));
      setUserData(JSON.parse(storedSession));
      const parsedTheme = JSON.parse(storedTheme);
      setcurrentuserId(JSON.parse(storedSession).userId);
      Setcolorcode(parsedTheme.landing_page_title_color);
      //console.log(JSON.parse(storedSession).name);
    } else {
      navigate("/login");
    }
  }, [navigate]);

  useEffect(() => {
    if (themeData) {
      const body = document.body;
      if (body.classList.contains("common-bg")) {
        body.style.backgroundImage =
          window.innerWidth <= 768
            ? `url(${themeData.background_mob})`
            : `url(${themeData.background_desk})`;
      }
    }
    console.log(themeData);
    //setstaticTimer(themeData.timer);
  }, [themeData]);

  useEffect(() => {
    if (!userData || !themeData) return;

    //console.log("Listening for game state changes--------1-------");

    const gameRef = doc(database, `sessions/${userData.sessionId}/themes/${themeData.themeName}`);
    console.log(`sessions/${userData.sessionId}/themes/${themeData.themeName}`);

    const unsubscribe = onSnapshot(gameRef, (docSnapshot) => {
      if (docSnapshot.exists()) {
        const gameData = docSnapshot.data();
        console.log("userData.userId", userData.userId);
        console.log("gameData.initialfund)--------", gameData.initialfund);
        //setGameStarted(gameData.liveData.usershow);
        setAccountDoc(userData, gameData.initialfund);
        setmarketopenData(gameData.market);
        setTransactionCharge(gameData.transcationcharge);
        setmarketInfoData(gameData.marketinfo);
        setinitialfundData(gameData.initialfund);
        loadNews(userData.sessionId);
        loadCompanies(userData.sessionId, themeData.themeName);
        userPortfolio(userData.userId, userData.sessionId);
        fetchAllPortfolio(userData.sessionId);


        console.log("initialFund----", gameData);
      } else {
        console.warn("Game session document does not exist.");
      }
    });

    return () => unsubscribe();

  }, [database, userData, themeData, setmarketopenData, setaccountBalance,setmarketInfoData, navigate]);
  // ✅ Improved checkAndCreateUser function

  async function setAccountDoc(parsedUser, userInitialFund) {
    if (!parsedUser || !parsedUser.userId) {
      console.error("Error: Missing user ID.");
      Swal.fire("Error", "User ID is missing.", "error");
      return;
    }

    const accountsCollectionRef = collection(database, "accounts");

    try {
      const q = query(accountsCollectionRef, where("userId", "==", parsedUser.userId),
        where("sessionId", "==", parsedUser.sessionId));
      const querySnapshot = await getDocs(q);

      if (querySnapshot.empty) {
        const newDocRef = await addDoc(accountsCollectionRef, {
          userId: parsedUser.userId,
          name: parsedUser.name,
          email: parsedUser.email,
          teamName: parsedUser.teamName,
          sessionId: parsedUser.sessionId,
          balance: parseInt(userInitialFund),
          initialFund: parseInt(userInitialFund),
          createdAt: new Date().toISOString(),
        });
        setuserAcount(true);

        console.log("New user document created with ID:", newDocRef.id);
      } else {
        console.log("User document already exists.");
      }
      userAccounts(parsedUser.userId, parsedUser.sessionId);
    } catch (error) {
      console.error("Error updating or creating user document:", error);
      Swal.fire("Error", "Something went wrong. Please try again.", "error");
    }
  }

  function loadNews(sessionId) {
    if (!sessionId) {
      console.warn("Session ID is missing. Cannot fetch news.");
      return;
    }

    const newsRef = collection(database, "news"); // Reference to "news" collection
    const q = query(
      newsRef,
      where("sessionId", "==", sessionId),
      where("islive", "==", true),
      orderBy("date", "desc") // ✅ Sorts by latest date first
    );

    getDocs(q)
      .then((querySnapshot) => {
        if (!querySnapshot.empty) {
          const newsData = querySnapshot.docs.map((doc) => ({
            id: doc.id, // Document ID
            ...doc.data(), // Document fields
          }));
          console.log("Fetched Live News Data:", newsData);
          setNews(newsData);
        } else {
          console.warn("No live news documents found for sessionId:", sessionId);
          setNews([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching live news:", error);
      });
  }

  function loadCompanies(sessionId, themename) {
    if (!sessionId) {
      console.warn("Session ID is missing. Cannot fetch news.");
      return;
    }

    const companiesRef = collection(database, "companies"); // Reference to "news" collection
    const q = query(
      companiesRef,
      where("sessionId", "==", sessionId),
      where("themename", "==", themename)
    ); // Filter by sessionId

    getDocs(q)
      .then((querySnapshot) => {
        if (!querySnapshot.empty) {
          const companiesData = querySnapshot.docs.map((doc) => ({
            id: doc.id, // Document ID
            compId: doc.id,
            ...doc.data(), // Document fields
          }));
          console.log("Fetched companies Data:", companiesData);
          setStocks(companiesData);
        } else {
          console.warn("No companies documents found for sessionId:", sessionId);
          setStocks([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching news:", error);
      });
  }

function fetchAllPortfolio(sessionId) {
    if (!sessionId) {
      console.warn("User ID or Session ID is missing. Cannot fetch portfolio data.");
      return;
    }

    const portfolioRef = collection(database, "portfolio"); // Reference to "portfolio" collection
    const q = query(
      portfolioRef,
      where("sessionId", "==", sessionId), // Ensure session matches
      where("qut", ">", 0) // Get only stocks with quantity greater than 0
    );

    getDocs(q)
      .then((querySnapshot) => {
        if (!querySnapshot.empty) {
          const portfolioData = querySnapshot.docs.map((doc) => ({
            id: doc.id, // Document ID
            ...doc.data(), // Document fields
          }));
          console.log("Fetched All Portfolio Data:", portfolioData);
          setAllPortfolio(portfolioData);
        } else {

          setAllPortfolio([]); // Set an empty portfolio if nothing is found
        }
      })
      .catch((error) => {
        console.error("Error fetching portfolio:", error);
      });
  }


  function userPortfolio(currentUserId, sessionId) {
    if (!currentUserId || !sessionId) {
      console.warn("User ID or Session ID is missing. Cannot fetch portfolio data.");
      return;
    }

    const portfolioRef = collection(database, "portfolio"); // Reference to "portfolio" collection
    const q = query(
      portfolioRef,
      where("userId", "==", currentUserId),
      where("sessionId", "==", sessionId), // Ensure session matches
      where("qut", ">", 0) // Get only stocks with quantity greater than 0
    );

    getDocs(q)
      .then((querySnapshot) => {
        if (!querySnapshot.empty) {
          const portfolioData = querySnapshot.docs.map((doc) => ({
            id: doc.id, // Document ID
            ...doc.data(), // Document fields
          }));
          console.log("Fetched Portfolio Data:", portfolioData);
          setPortfolio(portfolioData);
        } else {
          console.warn("No portfolio documents found for user:", currentUserId);
          setPortfolio([]); // Set an empty portfolio if nothing is found
        }
      })
      .catch((error) => {
        console.error("Error fetching portfolio:", error);
      });
  }
  function uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      const r = Math.random() * 16 | 0;
      const v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  function userAccounts(currentUserId, sessionId) {
    if (!currentUserId || !sessionId) {
      console.warn("User ID or Session ID is missing. Cannot fetch account data.");
      return;
    }

    const accountsRef = collection(database, "accounts"); // Reference to "accounts" collection
    const q = query(
      accountsRef,
      where("userId", "==", currentUserId),
      where("sessionId", "==", sessionId) // Ensure session matches
    );

    return getDocs(q)
      .then((querySnapshot) => {
        if (!querySnapshot.empty) {
          const accountsData = querySnapshot.docs.map((doc) => ({
            id: doc.id, // Document ID
            ...doc.data(), // Document fields
          }));

          setAccountdocId(accountsData[0].id);
          console.log("Fetched Account Balance:", accountsData[0].balance);
          setaccountBalance(accountsData[0].balance.toFixed(2));
          //setAccountdocId(doc.id);
        } else {
          console.warn("No account document found for this user/session.");
          setaccountBalance([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching account data:", error);
        return 0;
      });
  }

  useEffect(() => {
    const interval = setInterval(() => {
      setStocks((prevStocks) =>
        prevStocks.map((stock) => ({
          ...stock,
          price: (stock.price * (0.98 + Math.random() * 0.04)).toFixed(2),
        }))
      );
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  const openModal = (stock) => {
    setOrderLoaderButton(true);
    setSelectedStock(stock);
    setQuantity("");
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };
  const mobilehandledata = (buttonName) => {
    setActiveButton(buttonName); // Update active button state
    console.log(`${buttonName} clicked`);

    // Define the mapping between button names and class names
    const sectionClassMap = {
      portfolio: "portfolio",
      trade: "purchasestock",
      news: "newsfeed"
    };

    // Hide all sections first
    document.querySelectorAll(".portfolio, .purchasestock, .newsfeed").forEach((el) => {
      el.style.display = "none"; // Hide all sections
    });

    // Show the selected section if it exists
    const sectionClass = sectionClassMap[buttonName];
    if (sectionClass) {
      const selectedSection = document.querySelector(`.${sectionClass}`);
      if (selectedSection) {
        selectedSection.style.display = "block";
      } else {
        console.warn(`Section ${sectionClass} not found in the DOM.`);
      }
    }

     const livestockSection = document.querySelector(".livestock");
      if (livestockSection) {
        if (buttonName === "news") {
          livestockSection.style.display = "none";
        } else {
          livestockSection.style.display = "block";
        }
      }
  };
 const fetchStockDetails = async (companyDocId) => {
  try {
    // Make sure companyDocId is defined and a string
    if (!companyDocId) throw new Error("companyDocId is undefined");

    const docRef = doc(database, "companies", companyDocId); // ✅ correct
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      console.log("Stock data:", docSnap.data());
      return docSnap.data();
    } else {
      console.warn("No such document!");
      return null;
    }
  } catch (error) {
    console.error("Error fetching stock details:", error);
    return null;
  }
};
  const handleTrade = async (type) => {
    setOrderLoaderButton(false);

      let headers = {
        'client-secret': process.env.REACT_APP_FIREBASE_CLIENT_SECRET,
        'Content-Type': 'application/json',
      };

      if (userData.roles !== "GUEST_USER") {
        headers['Authorization'] = `Bearer ${userData.token}`;
      }

    // const headers = {
    //   'client-secret': process.env.REACT_APP_FIREBASE_CLIENT_SECRET,
    //   'Content-Type': 'application/json'
    // };
     const method = "POST";
      if (["POST", "PUT"].includes(method)) {
        headers["Idempotency-Key"] = uuidv4();
        console.log("Added Idempotency-Key:", headers["Idempotency-Key"]);
      }

    const requestData = {
      sessionId: userData.sessionId,
      userId: userData.userId,
      companyDoc: selectedStock.compId,
      accountDoc: accountId,
      themeId: themeData.themeName,
      type: type,
      qut: quantity,
      teamName: userData.teamName,
    };
    console.log(requestData);

    try {
      const response = await axios.post(
        process.env.REACT_APP_FIREBASE_SUBMIT_ORDER_API,
        requestData,
        { headers }
      );
      if (response.data.success) {
        // const companyDocId = response.data.companyDoc; // Firestore doc ID
        // console.log("companyDocId",response.data);
        const stockData = await fetchStockDetails(selectedStock.compId);
        console.log("stockData",stockData);

        if (stockData) {
          const learningBites = stockData.learningbites;
          const randomBite = learningBites[Math.floor(Math.random() * learningBites.length)];
          console.log("randomBite",randomBite);
          setIsModalOpen(false);
          // Show popup with company name + random learning bite
          handlePop(`${stockData.companyname}`, `${randomBite}`).then(() => {
            handleSuccess("Successful Transaction");
         
          });
        }
  
      } else {
        setOrderLoaderButton(true);
        handleError(response.data.message);
      }

    } catch (error) {
      console.error('Trade Failed:', error || 'An error occurred');
      setOrderLoaderButton(true);
      handleError('Trade failed! Please try again.');
    }
    console.log(`Trading ${quantity} shares of ${selectedStock.companyname}`);
    //closeModal();
  };

  return (

    <div>
      <div className="mobilebutton">
        {["portfolio", "trade", "news"].map((btn) => (
          <button
            key={btn}
            onClick={() => mobilehandledata(btn)}
            className={`${btn}btn`}
            style={{
              padding: "10px 15px",
              borderRadius: "5px",
              border: "none",
              cursor: "pointer",
              border: "1px solid #33339b",
              textTransform: "capitalize",
              backgroundColor: activeButton === btn ? "#c8480e" : "#18185e", // Change color when active
              color: "white",
              fontSize: "16px",
            }}
          >
            {btn}
          </button>
        ))}
      </div>

      {/* Trade Modal */}
      <Modal className="model"
        isOpen={isModalOpen}
        onRequestClose={closeModal}
      >
        <button
          onClick={closeModal}
          className="modelclose"
          style={{}}
        >
          <FontAwesomeIcon icon={faTimes} />
        </button>
        <h2 style={{ color: "white", marginBottom: "20px", marginTop: "20px" }}>Trade Stock</h2>

        {/* Company Selection Dropdown */}
        <select
          value={selectedStock ? selectedStock.companyname : ""}
          onChange={(e) => {
            const stock = stocks.find((s) => s.companyname === e.target.value);
            setSelectedStock(stock);
          }}
        >
          <option value="" disabled>Select Company</option>
          {stocks.map((stock) => (
            <option key={stock.id} value={stock.companyname}>
              {stock.companyname}
            </option>
          ))}
        </select>

        {/* Quantity Input (Disabled until company is selected) */}
        <input
          type="number"
          value={quantity === 0 ? "" : quantity} // 🚀 Show blank when cleared
          onChange={(e) => {
            const value = e.target.value;
            setQuantity(value === "" ? "" : Number(value)); // Keep empty string if cleared
          }}
          placeholder="Enter quantity"
          disabled={!selectedStock} // Disable if no company is selected
          style={{ backgroundColor: !selectedStock ? "#ccc" : "white" }} // Grey out if disabled
        />

        <br />
        <div style={{ marginBottom: "20px" }}>
          <span style={{color: "white"}}>
            <strong>Total:</strong>{" "}
            {selectedStock && quantity ? (
              <>
                ${((quantity * selectedStock.currentprice)).toFixed(2)}
                <p style={{ margin: 0, fontSize: "15px", color: "white" }}>
                  (Transaction fee ${transactionCharge} applies to each buy and sell order, affecting your final cost or earnings.)
                </p>

              </>
            ) : (
              "$0"
            )}
          </span>

        </div>

        {/* Handle Stock Availability Messages and Show Buttons */}
        {selectedStock ? (
          quantity && orderLoader > 0 ? (
            <>
              <button
                onClick={() => handleTrade("buy")}
                className="buy"
                style={{ marginRight: "10px" }}
              >
                BUY
              </button>

              <button
                onClick={() => handleTrade("sell")}
                className="sell"
                style={{ marginRight: "10px" }}
              >
                SELL
              </button>

            </>
          ) : null
        ) : (
          <p style={{ color: "white" }}>Select a company to enter quantity.</p> // 🛑 Prevent input before selection
        )}

      </Modal>


      <div>
        <div className="purchasestock" style={{ borderRadius: "8px", boxShadow: "2px 2px 8px rgba(0,0,0,0.1)" }}>
          <div className="purchasestockchild" style={{ border: "1px solid white", padding: "10px", borderRadius: "10px" }}>

            {/* Amount from account balance */}
            <h2>My funds: <span>${accountBalance}</span></h2>

            {/* Total Investment = Sum of (buyingPrice * quantity) */}
            <h2>
              My Investments:
              <span style={{ color: "#00d7e6" }}>
                {portfolio.reduce((total, item) => total + item.buyingPrice * item.qut, 0) === 0
                  ? "$0"
                  : `$${portfolio.reduce((total, item) => total + item.buyingPrice * item.qut, 0).toFixed(2)}`
                }
              </span>
            </h2>

            {userData?.teamName !== "NULL" && userData?.teamName ? (
              <h2>
                My Team's Investments:
                <span style={{ color: "#00d7e6" }}>
                  {(() => {
                    const teamName = userData.teamName;

                    const teamInvestments = allPortfolio
                      .filter(item => item.teamName === teamName)
                      .reduce((total, item) => total + item.buyingPrice * item.qut, 0);

                    return teamInvestments === 0
                      ? "$0"
                      : `$${teamInvestments.toFixed(2)}`;
                  })()}
                </span>
              </h2>
            ) : null}

            {/* Current Value = Sum of (currentPrice * quantity) */}
            <h2>
              Current Value:
              <span style={{ color: "yellow" }}>
                {portfolio.reduce((total, item) => {
                  const stock = stocks.find((s) => s.companyname === item.companyname);
                  return total + (stock ? stock.currentprice * item.qut : 0);
                }, 0) === 0
                  ? "$0"
                  : `$${portfolio.reduce((total, item) => {
                    const stock = stocks.find((s) => s.companyname === item.companyname);
                    return total + (stock ? stock.currentprice * item.qut : 0);
                  }, 0).toFixed(2)}`
                }
              </span>
            </h2>

            {/* Calculate PGL */}
            {(() => {
              const totalInvestment = portfolio.reduce((total, item) => total + item.buyingPrice * item.qut, 0);
              const currentValue = portfolio.reduce((total, item) => {
                const stock = stocks.find((s) => s.companyname === item.companyname);
                return total + (stock ? stock.currentprice * item.qut : 0);
              }, 0);
              const totalPGL = currentValue - totalInvestment; // Profit & Loss

              return (
                <h2>
                  My P&L:
                  <span style={{ color: totalPGL > 0 ? "green" : totalPGL < 0 ? "red" : "white" }}>
                    {totalPGL === 0 ? "$0" : `$${totalPGL.toFixed(2)}`}
                  </span>
                </h2>
              );
            })()}

            {/* teams P&L */}


            {userData?.teamName !== "NULL" && userData?.teamName ? (
              (() => {
                const teamName = userData.teamName;

                // 💰 Filter portfolio for this team
                const teamPortfolio = allPortfolio.filter(item => item.teamName === teamName);

                // 🏦 Calculate total investment and current value
                const totalInvestment = teamPortfolio.reduce(
                  (total, item) => total + item.buyingPrice * item.qut,
                  0
                );

                const currentValue = teamPortfolio.reduce((total, item) => {
                  const stock = stocks.find(s => s.companyname === item.companyname);
                  return total + (stock ? stock.currentprice * item.qut : 0);
                }, 0);

                const totalPGL = currentValue - totalInvestment;

                return (
                  <h2>
                    My Team's P&L:{" "}
                    <span
                      style={{
                        color:
                          totalPGL > 0
                            ? "green"
                            : totalPGL < 0
                            ? "red"
                            : "white",
                      }}
                    >
                      {totalPGL === 0 ? "$0" : `$${totalPGL.toFixed(2)}`}
                    </span>
                  </h2>
                );
              })()
            ) : null}

            {/* Market Status & Trade Button */}
            {marketopen ? (
              <button onClick={() => openModal()} className="trade" style={{ borderRadius: "4px" }}>
                Trade
              </button>
            ) : (
              <div className="marketclosedparent">
                <p className="marketclosed" style={{ color: "red" }}>Market is Closed</p>
                <p className="marketclosed" style={{ color: "red" }}>{marketinfo}</p>
              </div>
            )}

          </div>
        </div>


        <div className="maindata" style={{}}>
          <div className="livestock" style={{ "paddingLeft": "16px", "paddingRight": "16px", borderRadius: "8px", boxShadow: "2px 2px 8px rgba(0,0,0,0.1)" }}>
            <h2 style={{ color: textcolor }}>Live Stock Prices</h2>
            <div
              style={{
                scrollbarWidth: "none",
                height: "92vh",
                backgroundColor: "rgba(0, 0, 0, 0.7)", // Wrapped in quotes
                border: "1px solid white",
                borderRadius: "10px",
                overflowY: "scroll",
              }}
            >

              <table style={{ borderCollapse: "collapse", borderSpacing: 0 }}>
                <thead>
                  <tr>
                    <th>Company Name</th>
                    <th>Stock Price</th>
                    <th>Quantity</th>
                    <th>Current Price</th>
                    <th>Status</th>
                    <th>Profit/Loss</th>
                  </tr>
                </thead>
                <tbody>
                  {stocks.map((stock) => {
                    const profitLoss = stock.currentprice - stock.stockprice;
                    const isProfit = profitLoss > 0;
                    const isExpanded = expandedStock === stock.id;

                    return (
                      <React.Fragment key={stock.id}>
                        <tr
                          onClick={() => toggleExpand(stock.id)}
                          style={{
                            cursor: "pointer",
                            backgroundColor: isExpanded ? "#280a6cd0" : "transparent", // 🔹 highlight expanded row
                            transition: "background-color 0.3s ease",
                          }}
                        >
                          <td className="tooltip">
                            <div className="company-name">
                              {stock.companyname}
                              <span className="arrow-icon">
                                <FaBook size={24} color="#333" />
                                {/* {isExpanded ? "▲" : "▼"} */}
                              </span>
                            </div>
                          </td>
                          <td>{stock.stockprice}</td>
                          <td>{stock.currentQut}</td>
                          <td>{stock.currentprice.toFixed(2)}</td>
                          <td style={{ color: isProfit ? "green" : "red" }}>
                            {isProfit ? "▲" : "▼"}
                          </td>
                          <td style={{ color: isProfit ? "green" : "red" }}>
                            {profitLoss.toFixed(2)}
                          </td>
                        </tr>

                        {isExpanded && (
                          <tr className="desc-row">
                            <td colSpan="6" className="desc-cell">
                              {stock.desc}
                            </td>
                          </tr>
                        )}
                      </React.Fragment>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>

          <div className="newsfeedparent" style={{}}>
            <div
              className="newsfeed"
              style={{
                paddingLeft: "16px",
                paddingRight: "16px",
                borderRadius: "8px",
                boxShadow: "2px 2px 8px rgba(0,0,0,0.1)",
              }}
            >
              <h2 style={{ color: textcolor }}>News Feed</h2>
              <div style={{ scrollbarWidth: "none", backgroundColor: "rgba(0, 0, 0, 0.7)", border: "1px solid white", "borderRadius": "10px", height: "50vh", overflowY: "scroll" }}>
                <table>
                  <thead>
                    <tr>
                      <th>Company Name</th>
                      <th>News</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody className="newstable">
                    {news.map((news) => (
                      <tr key={news.id}>
                        <td>{news.companyname}</td>
                        <td>{news.info}</td>
                        <td>
                          {news.impacttype === "Positive" ? (
                            <span style={{ color: "green", fontWeight: "bold" }}> {news.impact}% ▲</span>
                          ) : (
                            <span style={{ color: "red", fontWeight: "bold" }}> {news.impact}% ▼</span>
                          )}
                        </td>

                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            <div className="portfolio" style={{ "paddingLeft": "16px", "paddingRight": "16px", borderRadius: "8px", boxShadow: "2px 2px 8px rgba(0,0,0,0.1)", }}>
              <h2 style={{ color: textcolor }}>My Portfolio</h2>
              <div style={{ scrollbarWidth: "none", backgroundColor: "rgba(0, 0, 0, 0.7)", border: "1px solid white", "borderRadius": "10px", height: "35vh", overflowY: "scroll", overflowStyle: "none" }}>
                <table>
                  <thead>
                    <tr>
                      <th>Company Name</th>
                      <th>Quantity</th>
                      <th>Buying Price</th>
                      <th>Current Price</th>
                      <th>Status</th>
                      <th>P&L</th>
                    </tr>
                  </thead>
                  <tbody>
                    {portfolio.length > 0 ? (
                      portfolio.map((item, index) => {
                        // Find the matching stock to get the current price
                        const stock = stocks.find(stock => stock.companyname === item.companyname);
                        const currentPrice = stock ? stock.currentprice : 0;

                        // Calculate profit/loss
                        const profitLoss = (currentPrice - item.buyingPrice) * item.qut;
                        const isProfit = profitLoss > 0;

                        return (
                          <tr key={index}>
                            <td>{item.companyname}</td>
                            <td>{item.qut}</td>
                            <td>{item.buyingPrice.toFixed(2)}</td>
                            <td>{currentPrice.toFixed(2)}</td>
                            <td style={{ color: isProfit ? "green" : "red" }}>
                              {isProfit ? "▲" : "▼"}
                            </td>
                            <td style={{ color: isProfit ? "green" : "red" }}>
                              {profitLoss.toFixed(2)}
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan="6">No stocks owned</td>
                      </tr>
                    )}
                  </tbody>
                </table>

              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

  );

};

export default UserPage;